import { useState } from "react";
import Autosuggest from "react-autosuggest";
import { Text, Stack, Box, Center, Spinner } from "@chakra-ui/react";
import EmptyBinSearch from "../Images/bin-search-empty.png";
import RedBin from "../Images/mcc-bin-search-hero.png";
import NoResult from "../Images/bin-search-no-result.png";
import { FaSpinner } from 'react-icons/fa';
import { Helmet } from "react-helmet-async";
import { useMediaQuery } from "react-responsive";

export default function BinCollection() {
    const [propertyAddress, setPropertyAddress] = useState("");
    const [propertySuggestions, setPropertySuggestions] = useState([]); 
    const [propertyDetails, setPropertyDetails] = useState([]);   
    const [propertyTimer, setPropertyTimer] = useState(null);
    const [binCollectionData, setBinCollectionData] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const endpoint = (window.location.origin === "https://forms.maitland.nsw.gov.au" ? 
        process.env.REACT_APP_APIURL : process.env.REACT_APP_NONPRODAPIURL);

    const isSmallScreen = useMediaQuery({
        query: "(max-width: 800px)"
    });

    function getBinCollectionData(propertyId) {
        fetch(endpoint + "wastetrack/bin-collection?propertyId=" + propertyId, {
            method: "GET"
        })
        .then(response => response.json())
        .then(response => {
            setBinCollectionData(response);
            setIsLoading(false);
        })
        .catch(error => {
            console.log(error);
            setBinCollectionData('');
            setIsLoading(false);
        });
    }

    // Set variables from autosuggest on Property Address to autocomplete PropertyAddress, Suburb and PostCode
    function SetPropertyAddressDetails(value) {

        setIsLoading(true);

        setPropertyDetails({
            full_address: value.full_address,
            address: value.address,
            assets: value.assets,
            category: value.category,
            propertyId: value.property_id
        });

        var newValue = value.full_address;
        document.getElementById('propertyId').innerText = value.property_id;
        // Get Bin data when customer clicks on the bin suggestion
        getBinCollectionData(value.property_id);

        // Return this value 
        return newValue;
    }

    // Input change for property
    const propertyInputChanged = () => {
        document.getElementById('loadingSpin').classList.remove("hidden");
        clearTimeout(propertyTimer);

        const newTimer = setTimeout(() => {
            AutoSuggestFunction();
        }, 500);

        setPropertyTimer(newTimer);
    }

    // Use AutoSuggest api from Wastetrack layer of ARCGIS, displayed only Maitland LGA Address
    function AutoSuggestFunction() {
        setTimeout(function(){
            var propertyAddress = document.getElementById('propertyAddress');
            if (propertyAddress.value.length < 1) {
                document.getElementById('loadingSpin').classList.add("hidden");
                setIsLoading(false);
            }

            if(propertyAddress.value.length > 4) {
                fetch(endpoint + "wastetrack/search-bin?addressText=" + propertyAddress.value.replace("'","''"), {
                    method: "GET"
                })
                .then(response => response.json())
                .then(response => {
                    document.getElementById('loadingSpin').classList.add("hidden");
                    const theseSuggestions = [];
                    var count = 0;
                    response.forEach(function(thisSuggestion) {
                        theseSuggestions[count] = thisSuggestion;
                        count++;
                    })

                    setPropertySuggestions(theseSuggestions.map(row => ({
                        full_address: row.full_address,
                        address: row.street_number + " " + row.street_name + ", " + row.suburb + ", " + row.postcode,
                        assets: row.assets,
                        category: row.category,
                        property_id: row.property_id
                    })));
                })
                .catch(error => {
                    console.log(error);
                    setBinCollectionData('');
                    setIsLoading(false);
                });
            }
        }, 200);
    }

    return(
        <>
        <Helmet>
            <meta http-equiv="Content-Security-Policy" content={`default-src 'self'; style-src 'self' https://maitlandapi.wpengine.com/mccds/ 'unsafe-inline'; 
                img-src 'self' data:; connect-src 'self' ${endpoint}wastetrack/`} />
        </Helmet>
        <Box marginTop="10px" border='1px' borderRadius='lg' borderColor='gray.100' boxShadow='lg' height={isSmallScreen ? "750px" : "500px"}
            bgColor="white">
        <Text marginLeft="5%" marginTop="20px" fontSize="md" fontWeight="bold" color="gray.700">SEARCH YOUR ADDRESS<span id="loadingSpin" className="hidden"> - SEARCHING <Spinner size="sm" /></span></Text>
        <Stack direction="row" >
            <Box width="90%" marginLeft="5%">
            <Autosuggest
                inputProps={{
                    autoComplete: "abcd",
                    name: "propertyAddress",
                    id: "propertyAddress",
                    value: propertyAddress,
                    onChange: (_event, { newValue }) => {
                        setPropertyAddress(newValue);
                    },
                    onBlur: (_event ) => {
                        var newValue = document.getElementById('propertyId').innerText;
                        getBinCollectionData(newValue);
                    }
                }}
                suggestions={propertySuggestions}
                onSuggestionsFetchRequested={async ({ value }) => {
                    if (!value) {
                        setPropertySuggestions([]);
                        return;
                    }
                    try {
                        propertyInputChanged();
                    } catch (e) {
                        console.log(e);
                    }
                }}
                onSuggestionsClearRequested={() => {
                    setPropertySuggestions([]);
                }}
                getSuggestionValue={suggestion => SetPropertyAddressDetails(suggestion)}
                renderSuggestion={suggestion => <div className="binSuggestion">
                    {suggestion.full_address}
                </div>}
            />
            <Text id="propertyId" style={{display: "none"}}></Text>
            </Box>
        </Stack>
        <br />
        <Stack direction="column" align="center" width="100%" >         
        {!isLoading &&
            <>               
            {!binCollectionData ?
                <img src={EmptyBinSearch} alt="Empty Bin Search" className="binWidth"/>
            : <> 
            {binCollectionData && propertyDetails.category !== "Commercial" && propertyDetails.assets !== "[]" ?
            <Box border='1px' borderRadius='lg' borderColor='gray.100' boxShadow='lg' width="90%">
                <Center>
                    <Stack direction="row" padding="5">
                        <Box>
                            <img src={RedBin} alt="Red Bin Search" />
                        </Box>
                        <Box paddingLeft="15px">
                            <br />
                            <Text fontSize="md" fontWeight="bold" color="gray.700">NEXT COLLECTION DAY</Text><br />
                            {!isSmallScreen && <>
                                <Text fontSize="2xl" fontWeight="900">{binCollectionData.nextCollection}</Text>
                                <Text fontSize="lg" color="gray.700"><span className="boldFont">Address:</span> {binCollectionData.unitNumber && `${binCollectionData.unitNumber}/`}{binCollectionData.streetNumber} {binCollectionData.streetName}, {binCollectionData.suburb}, {binCollectionData.postcode}</Text><br />
                                <Text fontSize="md" fontWeight="bold" color="gray.700">If we've got this wrong please&nbsp;
                                    <a href="https://www.maitland.nsw.gov.au/council/contact-us" target="_blank" rel="noreferrer">contact us.</a></Text>
                            </>}
                        </Box>
                    </Stack>
                </Center>
                {isSmallScreen && <><Center>
                                <Text fontSize="xl" fontWeight="900">{binCollectionData.nextCollection}</Text></Center>
                                <Center><Text fontSize="md" color="gray.700"><span className="boldFont">Address:</span> {binCollectionData.unitNumber && `${binCollectionData.unitNumber}/`}{binCollectionData.streetNumber} {binCollectionData.streetName}, {binCollectionData.suburb}, {binCollectionData.postcode}</Text><br />
                                </Center>
                                <br /><Center><Text fontSize="sm" fontWeight="bold" color="gray.700">If we've got this wrong please&nbsp;
                                    <a href="https://www.maitland.nsw.gov.au/council/contact-us" target="_blank" rel="noreferrer">contact us.</a></Text>
                            </Center></>}
                <Center>
                    <Stack direction={isSmallScreen ? "column" : "row"} padding="20px">
                        <Box textAlign="center">
                            <Text fontSize="md" fontWeight="bold" color="gray.700">Yellow Recycling Bin Collection</Text>
                            <Text fontSize="md"><a href="https://hrr.com.au/bin-info/collection-dates/" target="_blank" rel="noreferrer">Please visit Hunter Resource Recovery</a></Text>
                        </Box>
                        <Box width="50px">
                        </Box>
                        <Box textAlign="center">
                            <Text fontSize="md" fontWeight="bold">Green Organics Bin Collection</Text>
                            <Text fontSize="md"><a href="https://www.yourorganicsbin.com.au/" target="_blank" rel="noreferrer">Please visit Solo Resource Recovery</a></Text>
                        </Box>
                        <Box width="50px"></Box>
                        <Box textAlign="center">
                            <Text fontSize="md" fontWeight="bold">Bulky Waste Collection</Text>
                            <Text fontSize="md"><a href="https://wasteservices.maitland.nsw.gov.au/" target="_blank" rel="noreferrer">Please visit our Self service portal</a></Text>
                        </Box>
                    </Stack>
                </Center>
            </Box>
            :
            <>
                <Box border='1px' borderRadius='lg' borderColor='gray.100' boxShadow='lg' width="90%">
                <Center>
                    <Stack direction="row" padding="20px">
                        {propertyDetails.category === "Commercial" ? <>
                            <Box>
                                <Center>
                                    <Text fontSize="md" fontWeight="bold" color="gray.700">NEXT COLLECTION DAY</Text>
                                </Center><br />
                                <Center>
                                    <Text fontSize="2xl" fontWeight="900">Commercial Property</Text><br />
                                </Center>
                                <Center paddingBottom="10px" paddingTop="10px">
                                    <Text fontSize="lg" fontWeight="bold">
                                        The collection days for commercial properties are not available in this search.
                                        <br />
                                        Please contact Council or your waste contract provider for this information.
                                    </Text>
                                    <br />                            
                                </Center>
                                <Center>
                                    <Text fontSize="lg" color="gray.700"><span className="boldFont">Address:</span> {propertyAddress}</Text>                            
                                </Center>
                                <br />
                                <Center>
                                    <Text fontSize="md" fontWeight="bold" color="gray.700">If we've got this wrong please&nbsp;
                                        <a href="https://www.maitland.nsw.gov.au/council/contact-us" target="_blank" rel="noreferrer">contact us.</a></Text>
                                </Center>
                            </Box>
                        </> : 
                        <>                                                
                            <Box>
                                <img src={NoResult} alt="Red Bin Search" />
                            </Box>
                            <Box paddingLeft="15px">
                                <br />
                                <Text fontSize="md" fontWeight="bold" color="gray.700">NEXT COLLECTION DAY</Text><br />
                                <Text fontSize="2xl" fontWeight="900">Not Available</Text>
                                <Text fontSize="lg" color="grazy.700"><span className="boldFont">Address:</span> {propertyAddress}</Text><br />
                            <Text fontSize="md" fontWeight="bold" color="gray.700">If we've got this wrong please&nbsp;
                                <a href="https://www.maitland.nsw.gov.au/council/contact-us" target="_blank" rel="noreferrer">contact us.</a></Text>                         
                            </Box>
                        </>}
                    </Stack>
                </Center>
                <Center>
                    <Stack direction={isSmallScreen ? "column" : "row"} padding="20px">
                        <Box textAlign="center">
                            <Text fontSize="md" fontWeight="bold" color="gray.700">Yellow Recycling Bin Collection</Text>
                            <Text fontSize="md"><a href="https://hrr.com.au/bin-info/collection-dates/" target="_blank" rel="noreferrer">Please visit Hunter Recourse Recovery</a></Text>
                        </Box>
                        <Box width="50px">
                        </Box>
                        <Box textAlign="center">
                            <Text fontSize="md" fontWeight="bold" color="gray.700">Green Organics Bin Collection</Text>
                            <Text fontSize="md"><a href="https://www.yourorganicsbin.com.au/" target="_blank" rel="noreferrer">Please visit Solo Recourse Recovery</a></Text>
                        </Box>
                        <Box width="50px"></Box>
                        <Box textAlign="center">
                            <Text fontSize="md" fontWeight="bold">Bulky Waste Collection</Text>
                            <Text fontSize="md"><a href="https://wasteservices.maitland.nsw.gov.au/" target="_blank" rel="noreferrer">Please visit our Self service portal</a></Text>
                        </Box>
                    </Stack>
                </Center>
            </Box>
            </>
            }</>}
            </>}
            {isLoading &&
            <>
                <Box width="90%" height="320px">
                    <Center><Stack direction="row" marginTop="150px"><FaSpinner className="loaderIcon" /><Text fontSize="md" fontWeight="bold" color="gray.700">Loading...</Text></Stack></Center>
                </Box>
            </>}
                <Center><Text fontSize="md" fontWeight="bold" color="gray.700">Can't find your address?&nbsp;
                    <a href="https://www.maitland.nsw.gov.au/council/contact-us" target="_blank" rel="noreferrer">Please contact us.</a></Text></Center>
        </Stack>
        </Box>
        </>
    );
}